import {Component, HostListener, OnInit} from '@angular/core';
import {Simulador} from '../../classes/simulador';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

declare var $: any;

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnInit {
  Math = Math;

  contador  = 1;
  perguntas = 0;
  respostas = 0;

  constructor(private simulador: Simulador, private router: Router, public http: HttpClient) {
  }

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
      $event.returnValue = 'Você está saindo dessa simulação. Tem certeza?';
  }

  ngOnInit() {

    if (!this.simulador.index) {
      this.router.navigate(['/'], { skipLocationChange: true });
    }

    $(function () {
      $('.main-div:first-of-type').fadeIn('slow', function () {
        if ($('.main-div:first-of-type input').length > 0) {
          $('.main-div:first-of-type input').focus();
        } else {
          $('.main-div:first-of-type button').focus();
        }
      });

      $('input').each(function () {
        const self = $(this);
        if (self.data('mask')) { self.mask(self.data('mask')); }
      });
    });

    this.respostas = 0;
    this.perguntas = this.simulador.formulario.length;
    this.renderizarLabels();
  }

  finalizar() {
    const self = this;

    self.simulador.form = true;
    self.http.post('https://acesso.clinicavirtual.com.br/api-simulador/mini.php', {formulario: self.simulador.formulario, variaveis: self.simulador.variaveis}).subscribe(
      data => {
        self.router.navigate(['/final'], { skipLocationChange: true });
      },
      error => {
        alert('Erro ao enviar formulário, por favor, tente novamente mais tarde.');
      }
    );
  }

  mudar(index, acao) {
    const self = this;

    if (acao === 'avancar') { index++; } else { index--; }


    const antigo = self.simulador.formulario[index - 1];

    if (typeof antigo.callback === 'function') {
      antigo.callback(self.simulador, antigo, self.http, self.router);
    }

    $('.main-div:visible').fadeOut('slow', function () {
      self.renderizarLabels();

      if (acao === 'avancar') { self.contador++; } else { self.contador--; }

      if (typeof antigo !== 'undefined' && typeof antigo.conditional !== 'undefined') {
        for (const i of antigo.conditional) {
          if (antigo.fieldValue === i.if || i.if === null) {
            for (const alvo in self.simulador.formulario) {
              if (self.simulador.formulario[alvo].id == i.goto) { index = alvo; }
            }
          }
        }
      }

      if (acao === 'avancar') {
        if (typeof self.simulador.formulario[index] === 'undefined') {
          return self.finalizar();
        }
      }

      $('#main-div-' + index).fadeIn('slow', function () {
        if ($('#main-div-' + index + ' input').length > 0) {
          $('#main-div-' + index + ' input').focus();
        } else {
          $('#main-div-' + index + ' button').focus();
        }
      });

      self.respostas = index;
    });
  }

  renderizarLabels() {
    const self = this;

    for (const i of self.simulador.formulario) {
      let match = i.original_title.match(/\[\[(.*?)\]\]/g);

      i.title = i.original_title;

      if (match !== null && match.length > 0) {
        for (const ii in match) {
          const index = match[ii].replace(/[^0-9.]/g, '');

          for (const alvo in self.simulador.formulario) {
            if (self.simulador.formulario[alvo].id == index && self.simulador.formulario[alvo].fieldValue) {
              i.title = i.title.split(match[ii]).join(self.simulador.formulario[alvo].fieldValue);
            }
          }
        }
      }

      match = i.original_title.match(/\{\{(.*?)\}\}/g);

      if (match !== null && match.length > 0) {
        for (const ii in match) {
          const index = match[ii].replace(/\{\{/g, '').replace(/\}\}/g, '');

          for (const alvo in self.simulador.formulario) {
            if (self.simulador.formulario[alvo].id == index && self.simulador.formulario[alvo].fieldValue) {
              i.title = i.title.split(match[ii]).join(self.simulador.formulario[alvo].fieldValue.toString().toLowerCase());
            }
          }
        }
      }

      match = i.original_title.match(/\<\<(.*?)\>\>/g);

      if (match !== null && match.length > 0) {
        for (const ii in match) {
          const index = match[ii].replace(/\<\</g, '').replace(/\>\>/g, '');


          console.log(i.original_title, match, index, self.simulador.variaveis, self.simulador.variaveis[index]);

          for (const alvo in self.simulador.formulario) {
            if (typeof self.simulador.variaveis[index] === 'string') {
              i.title = i.title.split(match[ii]).join(self.simulador.variaveis[index].toString().toLowerCase());
            }
          }
        }
      }

      match = i.original_title.match(/\(\((.*?)\)\)/g);

      if (match !== null && match.length > 0) {
        for (const ii in match) {
          const index = match[ii].replace(/\(\(/g, '').replace(/\)\)/g, '');

          for (const alvo in self.simulador.formulario) {
            if (typeof self.simulador.variaveis[index] === 'string') {
              i.title = i.title.split(match[ii]).join(self.simulador.variaveis[index].toString().toLowerCase().replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
              }));
            }
          }
        }
      }
    }

  }

}
